import { PostWorkPlace } from "./ApiCalls/workPlace/postWorkPlace";
import { PatchWorkPlace } from "./ApiCalls/workPlace/patchWorkPlace";
import { GetWorkPlacesFromCompany } from "./ApiCalls/workPlace/getWorkPlacesFromCompany";
import { DisableWorkPlace } from "./ApiCalls/workPlace/disabledWorkPlace";
import i18n from 'i18next';

const authInfoString = localStorage.getItem("authInfo");
const authInfo = authInfoString ? JSON.parse(authInfoString) : {};
const modifiedBy = authInfo.idUser;

export async function PostWorkPlaceService(workPlace) {
    try {
        const workPlaceData = await PostWorkPlace(workPlace, modifiedBy);
        return true
    } catch (error) {
        // console.error("Error during login:", error);
        // Manejar el error

        return error;
    }
}

export async function PatchWorkPlaceService(workPlace, idWorkPlace) {
    try {
        const workPlaceData = await PatchWorkPlace(workPlace, modifiedBy, idWorkPlace);

        return true
    } catch (error) {
        // console.error("Error during login:", error);
        // Manejar el error
        return error;
    }
}

export async function GetWorkPlacesFromCompanyService(company) {
    const response = await GetWorkPlacesFromCompany(company);

    if (response.length > 0) {
        let workPlaces = response.map((workplace) => {
            return {
                workplaceId: workplace.workPlace.workPlace1,
                workplaceName: workplace.workPlace.name,
                responsibleWorkPlaceId: workplace.responsibleWorkPlace ? workplace.responsibleWorkPlace?.user1 : null,
                responsibleWorkPlaceFullName: workplace.responsibleWorkPlace ? `${workplace.responsibleWorkPlace.name} ${workplace.responsibleWorkPlace.surname}` : `${i18n.t("services:services.notAssigned")}`,
                responsibleWorkPlaceFullNameNIF: workplace.responsibleWorkPlace ? `${workplace.responsibleWorkPlace.name} ${workplace.responsibleWorkPlace.surname} (${workplace.responsibleWorkPlace.nif || ""})` : `${i18n.t("services:services.notAssigned")}`,
                workplaceEnabled: workplace.workPlace.enabled,
            }
        })

        workPlaces.sort((a, b) => {
            // Assuming workplaceEnabled is a boolean, true values will be sorted to come before false
            return (a.workplaceEnabled === b.workplaceEnabled) ? 0 : a.workplaceEnabled ? -1 : 1;
        });

        return workPlaces;
    } else {
        return []
    }
}

export async function DisabledWorkPlaceService(workPlace, idWorkPlace) {
    try {

        const workPlaceData = await DisableWorkPlace(workPlace, modifiedBy, idWorkPlace);

        return workPlaceData;
    } catch (error) {
        console.error("Error during disable workPlace:", error);
        // Manejar el error
        throw error;
    }
}



export async function GetWorkPlacesFromCompanyServiceFiltered(company) {
    const response = await GetWorkPlacesFromCompany(company);

    if (response.length > 0) {
        let workPlaces = response
            .filter(workplace => workplace.workPlace.enabled)
            .map((workplace) => {
                return {
                    workplaceId: workplace.workPlace.workPlace1,
                    workplaceName: workplace.workPlace.name,
                    responsibleWorkPlaceId: workplace.responsibleWorkPlace ? workplace.responsibleWorkPlace?.user1 : null,
                    responsibleWorkPlaceFullName: workplace.responsibleWorkPlace ? `${workplace.responsibleWorkPlace.name} ${workplace.responsibleWorkPlace.surname}` : `${i18n.t("services:services.notAssigned")}`,
                    responsibleWorkPlaceFullNameNIF: workplace.responsibleWorkPlace ? `${workplace.responsibleWorkPlace.name} ${workplace.responsibleWorkPlace.surname} (${workplace.responsibleWorkPlace.nif})` : `${i18n.t("services:services.notAssigned")}`,
                    workplaceEnabled: workplace.workPlace.enabled,
                }
            })

        return workPlaces;
    } else {
        return []
    }
}